import { FsEntryType } from '@lucidlink/sdk';
import { FilespaceEntryIdKeyFactory, FilespaceEntryPathKeyFactory, } from '#query-hooks';
export const seedOpenedDirCache = ({ dirId, dirPath, filespaceId, queryClient, }) => {
    queryClient.setQueryData(FilespaceEntryPathKeyFactory.exact(filespaceId, dirId), dirPath);
    queryClient.setQueryData(FilespaceEntryIdKeyFactory.exact(filespaceId, dirPath), { id: dirId, type: FsEntryType.DIR });
};
